document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cs-video-track]').forEach(function (track) {
    var list = track.querySelector('.cs-testimonial-video__list');
    var prev = track.querySelector('[data-cs-video-prev]');
    var next = track.querySelector('[data-cs-video-next]');
    if (!list) return;
    var scrollAmount = function () {
      var item = list.querySelector('.cs-testimonial-video__item');
      return item ? item.getBoundingClientRect().width + 24 : 260;
    };
    if (prev) prev.addEventListener('click', function () { list.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { list.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
});
